<template>
  <div class="page-bg page">
    <div class="main">
      <div class="page-content">
        <div class="sethead">
          <div class="back" @click="$router.go(-1)"></div>

          <div class="sethead-header">
            <ul>
              <li :class="{ active: isNav === 1 }" @click="isNav = 1">
                设置我的头像
              </li>
              <li :class="{ active: isNav === 2 }" @click="isNav = 2">
                生成头像图片
              </li>
            </ul>
          </div>
          <div class="sethead-body">
            <div class="img">
              <img :src="avatar" alt="" />
            </div>
            <div class="btn">
              <a class="btn-active" @click="setUserAvatarBtn()" v-if="isNav === 1">设置我的头像</a>
              <span class="btn-active" @click="downloadAvatar(avatar)" v-else>保存到手机相册</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>

import Vue from "vue";
import { mapActions, mapState } from "vuex";

import { Dialog, Toast } from "vant";
Vue.use(Dialog);
Vue.use(Toast);


export default {
  name: "user-treasure-sethead",
  data() {
    return {
      avatarTitle: "头像",
      avatar: this.$route.query.img ? this.$route.query.img : "", // 背景图
      isNav: 1,

    };
  },
  components: {},

  created() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;
  },
  methods: {    
    ...mapActions({
      updateUserAvatar: "user/updateUserAvatar",
  
    }),

    setUserAvatarBtn(){
      let that = this;

      if (!that.isLogin) {
        that.$router.push("/login");
        return false;
      }
      
      let avatar = this.avatar;
      let ToastLoading = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
      });
      that.updateUserAvatar({
        avatar,
        success: (res) => {
          ToastLoading.clear();
          console.log(res)
           if (res.status == 1) {
            Toast("操作成功");
          } else {
            Toast(res.message);
          }
        },
      });

    },
    downloadIamge(imgsrc, name) {
      //下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function() {
          var canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          var context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据'
          var a = document.createElement("a"); // 生成一个a元素
          var event = new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
              view: window
          }); // 创建一个单击事件
          a.download = name || "photo"; // 设置图片名称
          a.href = url; // 将生成的URL设置为a.href属性
          a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },

    
    downloadAvatar(url){
      let fileName =  new Date().getTime() + ".png";
      this.downloadIamge(url, fileName);
    }


  },
  computed: {
    ...mapState({
      isLogin: (state) => state.user.isLogin,
      userInfo: (state) => state.user.userInfo,
      guid: (state) => state.user.guid,
      security: (state) => state.user.security,
    }),

  },

  mounted() {},

  activated() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  background-size: cover;
  box-sizing: border-box;
  height: 100vh;
}

.main {
  width: 100%;
  box-sizing: border-box;
  height: 100vh;
  position: relative;
}
.page-content {
  position: relative;
  overflow-y: auto;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.5);
}

.back {
  position: fixed;
  left: 0.16rem;
  top: 0.3rem;
  width: 0.31rem;
  height: 0.36rem;
  background: url(../../../assets/images/common/back.png) no-repeat center;
  background-size: 100%;
  z-index: 99;
}
.sethead {
  padding: 1.5rem 0;
}

.sethead-header {
  text-align: center;
  li {
    display: inline-block;
    position: relative;
    color: #8c8c8c;
    font-size: 0.33rem;
    border-bottom: 0.03rem solid transparent;
    margin: 0 0.25rem;
    padding-bottom: 0.2rem;
    line-height: 1;
    color: rgba($color: #fff, $alpha: 0.3);
    &.active {
      color: #fff;
      border-color: #fff;
    }
  }
}
.sethead-body {
  padding: 0.6rem 0;

  .img {
    overflow: hidden;
    width: 6.09rem;
    height: 6.09rem;
    border: 0.03rem solid #ffffff;
    box-sizing: border-box;
    border-radius: 0.25rem;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .btn {
    margin-top: 1.4rem;
    a,span {
      display: block;
      color: #805407;
      font-size: 0.33rem;
      width: 5.72rem;
      line-height: 0.85rem;
      background-image: linear-gradient(left, #ecb649, #ea742a);
      border-radius: 0.85rem;
      text-align: center;
      margin: 0 auto;
    }
  }
}
</style>


